import * as React from 'react';

const DeliveryTruckRounded: React.FC = () => {
    return (
		<svg focusable="false" width="64" height="64" viewBox="42 42 60 60" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M101.2 70.78c0 15.61-12.65 28.27-28.27 28.27-15.61 0-28.27-12.65-28.27-28.27 0-15.61 12.65-28.27 28.27-28.27 15.61 0 28.27 12.66 28.27 28.27" fill="currentColor"/>
			<path fillRule="evenodd" clipRule="evenodd" d="M88.33 77.29h-.73v-7.62c0-.51-.18-1-.51-1.38l-4.16-4.81c-.4-.46-.98-.73-1.59-.73h-3.67v-1.82c0-1.7-1.38-3.08-3.07-3.08H59.76c-1.7 0-3.07 1.38-3.07 3.08v14.72c0 1.7 1.38 3.07 3.07 3.07h.23v.14c0 2.68 2.17 4.85 4.85 4.85s4.85-2.17 4.85-4.85v-.14h6.56v.14c-.04 2.68 2.11 4.87 4.78 4.91 2.68.04 4.87-2.11 4.91-4.78h2.42a.854.854 0 0 0 0-1.7m-6.99-12.84c.12 0 .23.05.31.14l4.08 4.71H77.7v-4.85h3.67ZM64.85 82.01A3.15 3.15 0 1 1 68 78.86a3.15 3.15 0 0 1-3.15 3.15m16.23 0a3.15 3.15 0 1 1 3.15-3.15 3.15 3.15 0 0 1-3.15 3.15" fill="#fff"/>
		</svg>
	);
};

export default React.memo(DeliveryTruckRounded);
